import React from "react";
import "./Profile.css";
import linkedin from "./images/linkedin.png";
import github from "./images/github.png";
import rofile from "./images/Profile.jpeg"

function Profile() {
  return (
    <div className="containerX">
      <div className="sidebar">
        <div className="Image">
          <img
            src={rofile}
            alt="Garv Jain"
          />
        </div>
        <div  className="AboutMe">
        <ul className="contact">
          <li className="g">
            <img className="link" src={linkedin} alt="linkedin" />
          </li>
          <li className="h">
            <img className="git" src={github} alt="Github" />
          </li>
        </ul>
        </div>
        <div class="containerBu">
          <div class="Button">
            <button>Connect</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
